let statuses = {
	incomplete: 10,
	notSettled: 20,
	settled: 30,
	invoiced: 40,
	recorded: 50,
	cancelled: 99,
};

function economicalStatuses(status) {
	switch (status) {
	case statuses.incomplete:
		return 'incomplete';
	case statuses.notSettled:
		return 'notSettled';
	case statuses.settled:
		return 'settled';
	case statuses.invoiced:
		return 'invoiced';
	case statuses.recorded:
		return 'recorded';
	case statuses.cancelled:
		return 'cancelled';
	default:
		return undefined;
	}
}

economicalStatuses.incomplete = statuses.incomplete;
economicalStatuses.notSettled = statuses.notSettled;
economicalStatuses.settled = statuses.settled;
economicalStatuses.invoiced = statuses.invoiced;
economicalStatuses.recorded = statuses.recorded;
economicalStatuses.cancelled = statuses.cancelled;

export default economicalStatuses;
